module.exports = __webpack_public_path__ + "img/3_5.ef7f0750.png";